module["exports"] = [
  "NSW",
  "QLD",
  "NT",
  "SA",
  "WA",
  "TAS",
  "ACT",
  "VIC"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/en_AU/address/state_abbr.js
// module id = 986
// module chunks = 0